// Recovered compiled webpack factory 58110. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      createKey: function () {
        return Y;
      },
      default: function () {
        return K;
      },
      matchesMiddleware: function () {
        return D;
      },
    }));
  let a = r(28140),
    o = r(49417),
    i = r(77700),
    s = r(24362),
    l = r(41402),
    u = o._(r(42444)),
    c = r(22461),
    f = r(61940),
    d = a._(r(82025)),
    p = r(62296),
    h = r(72421),
    _ = r(40579),
    m = r(92385),
    g = r(98156),
    y = r(47670);
  r(75078);
  let v = r(5240),
    b = r(79785),
    E = r(8518),
    R = r(51755),
    P = r(96058),
    S = r(92929),
    O = r(20935),
    T = r(42742),
    w = r(76293),
    j = r(52894),
    x = r(19649),
    A = r(58607),
    C = r(93913),
    M = r(13644),
    N = r(2471),
    k = r(84170),
    I = r(16832);
  function L() {
    return Object.assign(
      Object.defineProperty(Error("Route Cancelled"), "__NEXT_ERROR_CODE", {
        value: "E315",
        enumerable: !1,
        configurable: !0,
      }),
      { cancelled: !0 },
    );
  }
  async function D(e) {
    let t = await Promise.resolve(e.router.pageLoader.getMiddleware());
    if (!t) return !1;
    let { pathname: r } = (0, v.parsePath)(e.asPath),
      n = (0, S.hasBasePath)(r) ? (0, R.removeBasePath)(r) : r,
      a = (0, P.addBasePath)((0, b.addLocale)(n, e.locale));
    return t.some((e) => new RegExp(e.regexp).test(a));
  }
  function U(e) {
    let t = (0, p.getLocationOrigin)();
    return e.startsWith(t) ? e.substring(t.length) : e;
  }
  function H(e, t, r) {
    let [n, a] = (0, O.resolveHref)(e, t, !0),
      o = (0, p.getLocationOrigin)(),
      i = n.startsWith(o),
      s = a && a.startsWith(o);
    ((n = U(n)), (a = a ? U(a) : a));
    let l = i ? n : (0, P.addBasePath)(n),
      u = r ? U((0, O.resolveHref)(e, r)) : a || n;
    return { url: l, as: s ? u : (0, P.addBasePath)(u) };
  }
  function F(e, t) {
    let r = (0, i.removeTrailingSlash)((0, c.denormalizePagePath)(e));
    return "/404" === r || "/_error" === r
      ? e
      : (t.includes(r) ||
          t.some((t) => {
            if ((0, h.isDynamicRoute)(t) && (0, g.getRouteRegex)(t).re.test(r))
              return ((e = t), !0);
          }),
        (0, i.removeTrailingSlash)(e));
  }
  async function $(e) {
    if (!(await D(e)) || !e.fetchData) return null;
    let t = await e.fetchData(),
      r = await (function (e, t, r) {
        let a = {
            basePath: r.router.basePath,
            i18n: { locales: r.router.locales },
            trailingSlash: !1,
          },
          o = t.headers.get("x-nextjs-rewrite"),
          l = o || t.headers.get("x-nextjs-matched-path"),
          u = t.headers.get(I.MATCHED_PATH_HEADER);
        if (
          (!u ||
            l ||
            u.includes("__next_data_catchall") ||
            u.includes("/_error") ||
            u.includes("/404") ||
            (l = u),
          l)
        ) {
          if (l.startsWith("/")) {
            let t = (0, _.parseRelativeUrl)(l),
              u = (0, w.getNextPathnameInfo)(t.pathname, { nextConfig: a, parseData: !0 }),
              c = (0, i.removeTrailingSlash)(u.pathname);
            return Promise.all([
              r.router.pageLoader.getPageList(),
              (0, s.getClientBuildManifest)(),
            ]).then((a) => {
              let [i, { __rewrites: s }] = a,
                l = (0, b.addLocale)(u.pathname, u.locale);
              if (
                (0, h.isDynamicRoute)(l) ||
                (!o &&
                  i.includes(
                    (0, f.normalizeLocalePath)((0, R.removeBasePath)(l), r.router.locales).pathname,
                  ))
              ) {
                let r = (0, w.getNextPathnameInfo)((0, _.parseRelativeUrl)(e).pathname, {
                  nextConfig: void 0,
                  parseData: !0,
                });
                t.pathname = l = (0, P.addBasePath)(r.pathname);
              }
              {
                let e = n(l, i, s, t.query, (e) => F(e, i), r.router.locales);
                e.matchedPage &&
                  ((t.pathname = e.parsedAs.pathname),
                  (l = t.pathname),
                  Object.assign(t.query, e.parsedAs.query));
              }
              let d = i.includes(c)
                ? c
                : F(
                    (0, f.normalizeLocalePath)((0, R.removeBasePath)(t.pathname), r.router.locales)
                      .pathname,
                    i,
                  );
              if ((0, h.isDynamicRoute)(d)) {
                let e = (0, m.getRouteMatcher)((0, g.getRouteRegex)(d))(l);
                Object.assign(t.query, e || {});
              }
              return { type: "rewrite", parsedAs: t, resolvedHref: d };
            });
          }
          let t = (0, v.parsePath)(e);
          return Promise.resolve({
            type: "redirect-external",
            destination:
              "" +
              (0, j.formatNextPathnameInfo)({
                ...(0, w.getNextPathnameInfo)(t.pathname, { nextConfig: a, parseData: !0 }),
                defaultLocale: r.router.defaultLocale,
                buildId: "",
              }) +
              t.query +
              t.hash,
          });
        }
        let c = t.headers.get("x-nextjs-redirect");
        if (c) {
          if (c.startsWith("/")) {
            let e = (0, v.parsePath)(c),
              t = (0, j.formatNextPathnameInfo)({
                ...(0, w.getNextPathnameInfo)(e.pathname, { nextConfig: a, parseData: !0 }),
                defaultLocale: r.router.defaultLocale,
                buildId: "",
              });
            return Promise.resolve({
              type: "redirect-internal",
              newAs: "" + t + e.query + e.hash,
              newUrl: "" + t + e.query + e.hash,
            });
          }
          return Promise.resolve({ type: "redirect-external", destination: c });
        }
        return Promise.resolve({ type: "next" });
      })(t.dataHref, t.response, e);
    return {
      dataHref: t.dataHref,
      json: t.json,
      response: t.response,
      text: t.text,
      cacheKey: t.cacheKey,
      effect: r,
    };
  }
  n = r(7511).A;
  let B = Symbol("SSG_DATA_NOT_FOUND");
  function z(e) {
    try {
      return JSON.parse(e);
    } catch (e) {
      return null;
    }
  }
  function q(e) {
    let {
        dataHref: t,
        inflightCache: r,
        isPrefetch: n,
        hasMiddleware: a,
        isServerRender: o,
        parseJSON: i,
        persistCache: l,
        isBackground: u,
        unstable_skipClientCache: c,
      } = e,
      { href: f } = new URL(t, window.location.href),
      d = (e) => {
        var u;
        return (function e(t, r, n) {
          return fetch(t, {
            credentials: "same-origin",
            method: n.method || "GET",
            headers: Object.assign({}, n.headers, { "x-nextjs-data": "1" }),
          }).then((a) => (!a.ok && r > 1 && a.status >= 500 ? e(t, r - 1, n) : a));
        })(t, o ? 3 : 1, {
          headers: Object.assign(
            {},
            n ? { purpose: "prefetch" } : {},
            n && a ? { "x-middleware-prefetch": "1" } : {},
            { "x-deployment-id": "dpl_6RLyVc3L2qK5GpvsjXmfExxYVxRH" },
          ),
          method: null != (u = null == e ? void 0 : e.method) ? u : "GET",
        })
          .then((r) =>
            r.ok && (null == e ? void 0 : e.method) === "HEAD"
              ? { dataHref: t, response: r, text: "", json: {}, cacheKey: f }
              : r.text().then((e) => {
                  if (!r.ok) {
                    if (a && [301, 302, 307, 308].includes(r.status))
                      return { dataHref: t, response: r, text: e, json: {}, cacheKey: f };
                    if (404 === r.status) {
                      var n;
                      if (null == (n = z(e)) ? void 0 : n.notFound)
                        return {
                          dataHref: t,
                          json: { notFound: B },
                          response: r,
                          text: e,
                          cacheKey: f,
                        };
                    }
                    let i = Object.defineProperty(
                      Error("Failed to load static props"),
                      "__NEXT_ERROR_CODE",
                      { value: "E124", enumerable: !1, configurable: !0 },
                    );
                    throw (o || (0, s.markAssetError)(i), i);
                  }
                  return { dataHref: t, json: i ? z(e) : null, response: r, text: e, cacheKey: f };
                }),
          )
          .then(
            (e) => (
              (l && "no-cache" !== e.response.headers.get("x-middleware-cache")) || delete r[f],
              e
            ),
          )
          .catch((e) => {
            throw (
              c || delete r[f],
              ("Failed to fetch" === e.message ||
                "NetworkError when attempting to fetch resource." === e.message ||
                "Load failed" === e.message) &&
                (0, s.markAssetError)(e),
              e
            );
          });
      };
    return c && l
      ? d({}).then(
          (e) => (
            "no-cache" !== e.response.headers.get("x-middleware-cache") &&
              (r[f] = Promise.resolve(e)),
            e
          ),
        )
      : void 0 !== r[f]
        ? r[f]
        : (r[f] = d(u ? { method: "HEAD" } : {}));
  }
  function Y() {
    return Math.random().toString(36).slice(2, 10);
  }
  function X(e) {
    let { url: t, router: r } = e;
    if (t === (0, P.addBasePath)((0, b.addLocale)(r.asPath, r.locale)))
      throw Object.defineProperty(
        Error("Invariant: attempted to hard navigate to the same URL " + t + " " + location.href),
        "__NEXT_ERROR_CODE",
        { value: "E282", enumerable: !1, configurable: !0 },
      );
    window.location.href = t;
  }
  let W = (e) => {
    let { route: t, router: r } = e,
      n = !1,
      a = (r.clc = () => {
        n = !0;
      });
    return () => {
      if (n) {
        let e = Object.defineProperty(
          Error('Abort fetching component for route: "' + t + '"'),
          "__NEXT_ERROR_CODE",
          { value: "E483", enumerable: !1, configurable: !0 },
        );
        throw ((e.cancelled = !0), e);
      }
      a === r.clc && (r.clc = null);
    };
  };
  class K {
    reload() {
      window.location.reload();
    }
    back() {
      window.history.back();
    }
    forward() {
      window.history.forward();
    }
    push(e, t, r) {
      return (
        void 0 === r && (r = {}),
        ({ url: e, as: t } = H(this, e, t)),
        this.change("pushState", e, t, r)
      );
    }
    replace(e, t, r) {
      return (
        void 0 === r && (r = {}),
        ({ url: e, as: t } = H(this, e, t)),
        this.change("replaceState", e, t, r)
      );
    }
    async _bfl(e, t, n, a) {
      {
        if (!this._bfl_s && !this._bfl_d) {
          let t,
            o,
            { BloomFilter: i } = r(71727);
          try {
            ({ __routerFilterStatic: t, __routerFilterDynamic: o } = await (0,
            s.getClientBuildManifest)());
          } catch (t) {
            if ((console.error(t), a)) return !0;
            return (
              X({
                url: (0, P.addBasePath)((0, b.addLocale)(e, n || this.locale, this.defaultLocale)),
                router: this,
              }),
              new Promise(() => {})
            );
          }
          ((null == t ? void 0 : t.numHashes) &&
            ((this._bfl_s = new i(t.numItems, t.errorRate)), this._bfl_s.import(t)),
            (null == o ? void 0 : o.numHashes) &&
              ((this._bfl_d = new i(o.numItems, o.errorRate)), this._bfl_d.import(o)));
        }
        let c = !1,
          f = !1;
        for (let { as: r, allowMatchCurrent: s } of [{ as: e }, { as: t }])
          if (r) {
            let t = (0, i.removeTrailingSlash)(new URL(r, "http://n").pathname),
              d = (0, P.addBasePath)((0, b.addLocale)(t, n || this.locale));
            if (s || t !== (0, i.removeTrailingSlash)(new URL(this.asPath, "http://n").pathname)) {
              var o, l, u;
              for (let e of ((c =
                c ||
                !!(null == (o = this._bfl_s) ? void 0 : o.contains(t)) ||
                !!(null == (l = this._bfl_s) ? void 0 : l.contains(d))),
              [t, d])) {
                let t = e.split("/");
                for (let e = 0; !f && e < t.length + 1; e++) {
                  let r = t.slice(0, e).join("/");
                  if (r && (null == (u = this._bfl_d) ? void 0 : u.contains(r))) {
                    f = !0;
                    break;
                  }
                }
              }
              if (c || f) {
                if (a) return !0;
                return (
                  X({
                    url: (0, P.addBasePath)(
                      (0, b.addLocale)(e, n || this.locale, this.defaultLocale),
                    ),
                    router: this,
                  }),
                  new Promise(() => {})
                );
              }
            }
          }
      }
      return !1;
    }
    async change(e, t, r, a, o) {
      var c, f, d, O, T, w, j, C, k;
      let I, U;
      if (!(0, A.isLocalURL)(t)) return (X({ url: t, router: this }), !1);
      let $ = 1 === a._h;
      $ || a.shallow || (await this._bfl(r, void 0, a.locale));
      let z =
          $ ||
          a._shouldResolveHref ||
          (0, v.parsePath)(t).pathname === (0, v.parsePath)(r).pathname,
        q = { ...this.state },
        Y = !0 !== this.isReady;
      this.isReady = !0;
      let W = this.isSsr;
      if (($ || (this.isSsr = !1), $ && this.clc)) return !1;
      let G = q.locale;
      p.ST && performance.mark("routeChange");
      let { shallow: V = !1, scroll: J = !0 } = a,
        Q = { shallow: V };
      (this._inFlightRoute &&
        this.clc &&
        (W || K.events.emit("routeChangeError", L(), this._inFlightRoute, Q),
        this.clc(),
        (this.clc = null)),
        (r = (0, P.addBasePath)(
          (0, b.addLocale)(
            (0, S.hasBasePath)(r) ? (0, R.removeBasePath)(r) : r,
            a.locale,
            this.defaultLocale,
          ),
        )));
      let Z = (0, E.removeLocale)((0, S.hasBasePath)(r) ? (0, R.removeBasePath)(r) : r, q.locale);
      this._inFlightRoute = r;
      let ee = G !== q.locale;
      if (!$ && this.onlyAHashChange(Z) && !ee) {
        ((q.asPath = Z),
          K.events.emit("hashChangeStart", r, Q),
          this.changeState(e, t, r, { ...a, scroll: !1 }),
          J && this.scrollToHash(Z));
        try {
          await this.set(q, this.components[q.route], null);
        } catch (e) {
          throw ((0, u.default)(e) && e.cancelled && K.events.emit("routeChangeError", e, Z, Q), e);
        }
        return (K.events.emit("hashChangeComplete", r, Q), !0);
      }
      let et = (0, _.parseRelativeUrl)(t),
        { pathname: er, query: en } = et;
      try {
        [I, { __rewrites: U }] = await Promise.all([
          this.pageLoader.getPageList(),
          (0, s.getClientBuildManifest)(),
          this.pageLoader.getMiddleware(),
        ]);
      } catch (e) {
        return (X({ url: r, router: this }), !1);
      }
      this.urlIsNew(Z) || ee || (e = "replaceState");
      let ea = r;
      er = er ? (0, i.removeTrailingSlash)((0, R.removeBasePath)(er)) : er;
      let eo = (0, i.removeTrailingSlash)(er),
        ei = r.startsWith("/") && (0, _.parseRelativeUrl)(r).pathname;
      if (null == (c = this.components[er]) ? void 0 : c.__appRouter)
        return (X({ url: r, router: this }), new Promise(() => {}));
      let es = !!(
          ei &&
          eo !== ei &&
          (!(0, h.isDynamicRoute)(eo) || !(0, m.getRouteMatcher)((0, g.getRouteRegex)(eo))(ei))
        ),
        el = !a.shallow && (await D({ asPath: r, locale: q.locale, router: this }));
      if (($ && el && (z = !1), z && "/_error" !== er))
        if (((a._shouldResolveHref = !0), r.startsWith("/"))) {
          let e = n(
            (0, P.addBasePath)((0, b.addLocale)(Z, q.locale), !0),
            I,
            U,
            en,
            (e) => F(e, I),
            this.locales,
          );
          if (e.externalDest) return (X({ url: r, router: this }), !0);
          (el || (ea = e.asPath),
            e.matchedPage &&
              e.resolvedHref &&
              ((er = e.resolvedHref),
              (et.pathname = (0, P.addBasePath)(er)),
              el || (t = (0, y.formatWithValidation)(et))));
        } else
          ((et.pathname = F(er, I)),
            et.pathname !== er &&
              ((er = et.pathname),
              (et.pathname = (0, P.addBasePath)(er)),
              el || (t = (0, y.formatWithValidation)(et))));
      if (!(0, A.isLocalURL)(r)) return (X({ url: r, router: this }), !1);
      ((ea = (0, E.removeLocale)((0, R.removeBasePath)(ea), q.locale)),
        (eo = (0, i.removeTrailingSlash)(er)));
      let eu = !1;
      if ((0, h.isDynamicRoute)(eo)) {
        let e = (0, _.parseRelativeUrl)(ea),
          n = e.pathname,
          a = (0, g.getRouteRegex)(eo);
        eu = (0, m.getRouteMatcher)(a)(n);
        let o = eo === n,
          i = o ? (0, N.interpolateAs)(eo, n, en) : {};
        if (eu && (!o || i.result))
          o
            ? (r = (0, y.formatWithValidation)(
                Object.assign({}, e, { pathname: i.result, query: (0, M.omit)(en, i.params) }),
              ))
            : Object.assign(en, eu);
        else {
          let e = Object.keys(a.groups).filter((e) => !en[e] && !a.groups[e].optional);
          if (e.length > 0 && !el)
            throw Object.defineProperty(
              Error(
                (o
                  ? "The provided `href` (" +
                    t +
                    ") value is missing query values (" +
                    e.join(", ") +
                    ") to be interpolated properly. "
                  : "The provided `as` value (" +
                    n +
                    ") is incompatible with the `href` value (" +
                    eo +
                    "). ") +
                  "Read more: https://nextjs.org/docs/messages/" +
                  (o ? "href-interpolation-failed" : "incompatible-href-as"),
              ),
              "__NEXT_ERROR_CODE",
              { value: "E344", enumerable: !1, configurable: !0 },
            );
        }
      }
      $ || K.events.emit("routeChangeStart", r, Q);
      let ec = "/404" === this.pathname || "/_error" === this.pathname;
      try {
        let n = await this.getRouteInfo({
          route: eo,
          pathname: er,
          query: en,
          as: r,
          resolvedAs: ea,
          routeProps: Q,
          locale: q.locale,
          isPreview: q.isPreview,
          hasMiddleware: el,
          unstable_skipClientCache: a.unstable_skipClientCache,
          isQueryUpdating: $ && !this.isFallback,
          isMiddlewareRewrite: es,
        });
        if (
          ($ ||
            a.shallow ||
            (await this._bfl(r, "resolvedAs" in n ? n.resolvedAs : void 0, q.locale)),
          "route" in n && el)
        ) {
          ((eo = er = n.route || eo), Q.shallow || (en = Object.assign({}, n.query || {}, en)));
          let e = (0, S.hasBasePath)(et.pathname)
            ? (0, R.removeBasePath)(et.pathname)
            : et.pathname;
          if (
            (eu &&
              er !== e &&
              Object.keys(eu).forEach((e) => {
                eu && en[e] === eu[e] && delete en[e];
              }),
            (0, h.isDynamicRoute)(er))
          ) {
            let e =
              !Q.shallow && n.resolvedAs
                ? n.resolvedAs
                : (0, P.addBasePath)(
                    (0, b.addLocale)(new URL(r, location.href).pathname, q.locale),
                    !0,
                  );
            (0, S.hasBasePath)(e) && (e = (0, R.removeBasePath)(e));
            let t = (0, g.getRouteRegex)(er),
              a = (0, m.getRouteMatcher)(t)(new URL(e, location.href).pathname);
            a && Object.assign(en, a);
          }
        }
        if ("type" in n)
          if ("redirect-internal" === n.type) return this.change(e, n.newUrl, n.newAs, a);
          else return (X({ url: n.destination, router: this }), new Promise(() => {}));
        let i = n.Component;
        if (
          (i &&
            i.unstable_scriptLoader &&
            [].concat(i.unstable_scriptLoader()).forEach((e) => {
              (0, l.handleClientScriptLoad)(e.props);
            }),
          (n.__N_SSG || n.__N_SSP) && n.props)
        ) {
          if (n.props.pageProps && n.props.pageProps.__N_REDIRECT) {
            a.locale = !1;
            let t = n.props.pageProps.__N_REDIRECT;
            if (t.startsWith("/") && !1 !== n.props.pageProps.__N_REDIRECT_BASE_PATH) {
              let r = (0, _.parseRelativeUrl)(t);
              r.pathname = F(r.pathname, I);
              let { url: n, as: o } = H(this, t, t);
              return this.change(e, n, o, a);
            }
            return (X({ url: t, router: this }), new Promise(() => {}));
          }
          if (((q.isPreview = !!n.props.__N_PREVIEW), n.props.notFound === B)) {
            let e;
            try {
              (await this.fetchComponent("/404"), (e = "/404"));
            } catch (t) {
              e = "/_error";
            }
            if (
              ((n = await this.getRouteInfo({
                route: e,
                pathname: e,
                query: en,
                as: r,
                resolvedAs: ea,
                routeProps: { shallow: !1 },
                locale: q.locale,
                isPreview: q.isPreview,
                isNotFound: !0,
              })),
              "type" in n)
            )
              throw Object.defineProperty(
                Error("Unexpected middleware effect on /404"),
                "__NEXT_ERROR_CODE",
                { value: "E158", enumerable: !1, configurable: !0 },
              );
          }
        }
        $ &&
          "/_error" === this.pathname &&
          (null == (d = self.__NEXT_DATA__.props) || null == (f = d.pageProps)
            ? void 0
            : f.statusCode) === 500 &&
          (null == (O = n.props) ? void 0 : O.pageProps) &&
          (n.props.pageProps.statusCode = 500);
        let s = a.shallow && q.route === (null != (T = n.route) ? T : eo),
          c = null != (w = a.scroll) ? w : !$ && !s,
          p = null != o ? o : c ? { x: 0, y: 0 } : null,
          y = { ...q, route: eo, pathname: er, query: en, asPath: Z, isFallback: !1 };
        if ($ && ec) {
          if (
            ((n = await this.getRouteInfo({
              route: this.pathname,
              pathname: this.pathname,
              query: en,
              as: r,
              resolvedAs: ea,
              routeProps: { shallow: !1 },
              locale: q.locale,
              isPreview: q.isPreview,
              isQueryUpdating: $ && !this.isFallback,
            })),
            "type" in n)
          )
            throw Object.defineProperty(
              Error("Unexpected middleware effect on " + this.pathname),
              "__NEXT_ERROR_CODE",
              { value: "E225", enumerable: !1, configurable: !0 },
            );
          "/_error" === this.pathname &&
            (null == (C = self.__NEXT_DATA__.props) || null == (j = C.pageProps)
              ? void 0
              : j.statusCode) === 500 &&
            (null == (k = n.props) ? void 0 : k.pageProps) &&
            (n.props.pageProps.statusCode = 500);
          try {
            await this.set(y, n, p);
          } catch (e) {
            throw (
              (0, u.default)(e) && e.cancelled && K.events.emit("routeChangeError", e, Z, Q),
              e
            );
          }
          return !0;
        }
        if (
          (K.events.emit("beforeHistoryChange", r, Q),
          this.changeState(e, t, r, a),
          !($ && !p && !Y && !ee && (0, x.compareRouterStates)(y, this.state)))
        ) {
          try {
            await this.set(y, n, p);
          } catch (e) {
            if (e.cancelled) n.error = n.error || e;
            else throw e;
          }
          if (n.error) throw ($ || K.events.emit("routeChangeError", n.error, Z, Q), n.error);
          ($ || K.events.emit("routeChangeComplete", r, Q),
            c && /#.+$/.test(r) && this.scrollToHash(r));
        }
        return !0;
      } catch (e) {
        if ((0, u.default)(e) && e.cancelled) return !1;
        throw e;
      }
    }
    changeState(e, t, r, n) {
      (void 0 === n && (n = {}),
        ("pushState" !== e || (0, p.getURL)() !== r) &&
          ((this._shallow = n.shallow),
          window.history[e](
            {
              url: t,
              as: r,
              options: n,
              __N: !0,
              key: (this._key = "pushState" !== e ? this._key : Y()),
            },
            "",
            r,
          )));
    }
    async handleRouteInfoError(e, t, r, n, a, o) {
      if (e.cancelled) throw e;
      if ((0, s.isAssetError)(e) || o)
        throw (K.events.emit("routeChangeError", e, n, a), X({ url: n, router: this }), L());
      console.error(e);
      try {
        let n,
          { page: a, styleSheets: o } = await this.fetchComponent("/_error"),
          i = { props: n, Component: a, styleSheets: o, err: e, error: e };
        if (!i.props)
          try {
            i.props = await this.getInitialProps(a, { err: e, pathname: t, query: r });
          } catch (e) {
            (console.error("Error in error page `getInitialProps`: ", e), (i.props = {}));
          }
        return i;
      } catch (e) {
        return this.handleRouteInfoError(
          (0, u.default)(e)
            ? e
            : Object.defineProperty(Error(e + ""), "__NEXT_ERROR_CODE", {
                value: "E394",
                enumerable: !1,
                configurable: !0,
              }),
          t,
          r,
          n,
          a,
          !0,
        );
      }
    }
    async getRouteInfo(e) {
      let {
          route: t,
          pathname: r,
          query: n,
          as: a,
          resolvedAs: o,
          routeProps: s,
          locale: l,
          hasMiddleware: c,
          isPreview: d,
          unstable_skipClientCache: p,
          isQueryUpdating: h,
          isMiddlewareRewrite: _,
          isNotFound: m,
        } = e,
        g = t;
      try {
        var v, b, E, P;
        let e = this.components[g];
        if (s.shallow && e && this.route === g) return e;
        let t = W({ route: g, router: this });
        c && (e = void 0);
        let u = !e || "initial" in e ? void 0 : e,
          S = {
            dataHref: this.pageLoader.getDataHref({
              href: (0, y.formatWithValidation)({ pathname: r, query: n }),
              skipInterpolation: !0,
              asPath: m ? "/404" : o,
              locale: l,
            }),
            hasMiddleware: !0,
            isServerRender: this.isSsr,
            parseJSON: !0,
            inflightCache: h ? this.sbc : this.sdc,
            persistCache: !d,
            isPrefetch: !1,
            unstable_skipClientCache: p,
            isBackground: h,
          },
          O =
            h && !_
              ? null
              : await $({
                  fetchData: () => q(S),
                  asPath: m ? "/404" : o,
                  locale: l,
                  router: this,
                }).catch((e) => {
                  if (h) return null;
                  throw e;
                });
        if (
          (O && ("/_error" === r || "/404" === r) && (O.effect = void 0),
          h && (O ? (O.json = self.__NEXT_DATA__.props) : (O = { json: self.__NEXT_DATA__.props })),
          t(),
          (null == O || null == (v = O.effect) ? void 0 : v.type) === "redirect-internal" ||
            (null == O || null == (b = O.effect) ? void 0 : b.type) === "redirect-external")
        )
          return O.effect;
        if ((null == O || null == (E = O.effect) ? void 0 : E.type) === "rewrite") {
          let t = (0, i.removeTrailingSlash)(O.effect.resolvedHref),
            a = await this.pageLoader.getPageList();
          if (
            (!h || a.includes(t)) &&
            ((g = t),
            (r = O.effect.resolvedHref),
            (n = { ...n, ...O.effect.parsedAs.query }),
            (o = (0, R.removeBasePath)(
              (0, f.normalizeLocalePath)(O.effect.parsedAs.pathname, this.locales).pathname,
            )),
            (e = this.components[g]),
            s.shallow && e && this.route === g && !c)
          )
            return { ...e, route: g };
        }
        if ((0, T.isAPIRoute)(g)) return (X({ url: a, router: this }), new Promise(() => {}));
        let w =
            u ||
            (await this.fetchComponent(g).then((e) => ({
              Component: e.page,
              styleSheets: e.styleSheets,
              __N_SSG: e.mod.__N_SSG,
              __N_SSP: e.mod.__N_SSP,
            }))),
          j = null == O || null == (P = O.response) ? void 0 : P.headers.get("x-middleware-skip"),
          x = w.__N_SSG || w.__N_SSP;
        j && (null == O ? void 0 : O.dataHref) && delete this.sdc[O.dataHref];
        let { props: A, cacheKey: C } = await this._getData(async () => {
          if (x) {
            if ((null == O ? void 0 : O.json) && !j) return { cacheKey: O.cacheKey, props: O.json };
            let e = (null == O ? void 0 : O.dataHref)
                ? O.dataHref
                : this.pageLoader.getDataHref({
                    href: (0, y.formatWithValidation)({ pathname: r, query: n }),
                    asPath: o,
                    locale: l,
                  }),
              t = await q({
                dataHref: e,
                isServerRender: this.isSsr,
                parseJSON: !0,
                inflightCache: j ? {} : this.sdc,
                persistCache: !d,
                isPrefetch: !1,
                unstable_skipClientCache: p,
              });
            return { cacheKey: t.cacheKey, props: t.json || {} };
          }
          return {
            headers: {},
            props: await this.getInitialProps(w.Component, {
              pathname: r,
              query: n,
              asPath: a,
              locale: l,
              locales: this.locales,
              defaultLocale: this.defaultLocale,
            }),
          };
        });
        return (
          w.__N_SSP && S.dataHref && C && delete this.sdc[C],
          this.isPreview ||
            !w.__N_SSG ||
            h ||
            q(
              Object.assign({}, S, { isBackground: !0, persistCache: !1, inflightCache: this.sbc }),
            ).catch(() => {}),
          (A.pageProps = Object.assign({}, A.pageProps)),
          (w.props = A),
          (w.route = g),
          (w.query = n),
          (w.resolvedAs = o),
          (this.components[g] = w),
          w
        );
      } catch (e) {
        return this.handleRouteInfoError((0, u.getProperError)(e), r, n, a, s);
      }
    }
    set(e, t, r) {
      return ((this.state = e), this.sub(t, this.components["/_app"].Component, r));
    }
    beforePopState(e) {
      this._bps = e;
    }
    onlyAHashChange(e) {
      if (!this.asPath) return !1;
      let [t, r] = this.asPath.split("#", 2),
        [n, a] = e.split("#", 2);
      return (!!a && t === n && r === a) || (t === n && r !== a);
    }
    scrollToHash(e) {
      let [, t = ""] = e.split("#", 2);
      (0, k.disableSmoothScrollDuringRouteTransition)(
        () => {
          if ("" === t || "top" === t) return void window.scrollTo(0, 0);
          let e = decodeURIComponent(t),
            r = document.getElementById(e);
          if (r) return void r.scrollIntoView();
          let n = document.getElementsByName(e)[0];
          n && n.scrollIntoView();
        },
        { onlyHashChange: this.onlyAHashChange(e) },
      );
    }
    urlIsNew(e) {
      return this.asPath !== e;
    }
    async prefetch(e, t, r) {
      if (
        (void 0 === t && (t = e),
        void 0 === r && (r = {}),
        (0, C.isBot)(window.navigator.userAgent))
      )
        return;
      let a = (0, _.parseRelativeUrl)(e),
        o = a.pathname,
        { pathname: l, query: u } = a,
        c = l,
        f = await this.pageLoader.getPageList(),
        d = t,
        p = void 0 !== r.locale ? r.locale || void 0 : this.locale,
        S = await D({ asPath: t, locale: p, router: this });
      if (t.startsWith("/")) {
        let r;
        ({ __rewrites: r } = await (0, s.getClientBuildManifest)());
        let o = n(
          (0, P.addBasePath)((0, b.addLocale)(t, this.locale), !0),
          f,
          r,
          a.query,
          (e) => F(e, f),
          this.locales,
        );
        if (o.externalDest) return;
        (S || (d = (0, E.removeLocale)((0, R.removeBasePath)(o.asPath), this.locale)),
          o.matchedPage &&
            o.resolvedHref &&
            ((a.pathname = l = o.resolvedHref), S || (e = (0, y.formatWithValidation)(a))));
      }
      ((a.pathname = F(a.pathname, f)),
        (0, h.isDynamicRoute)(a.pathname) &&
          ((l = a.pathname),
          (a.pathname = l),
          Object.assign(
            u,
            (0, m.getRouteMatcher)((0, g.getRouteRegex)(a.pathname))(
              (0, v.parsePath)(t).pathname,
            ) || {},
          ),
          S || (e = (0, y.formatWithValidation)(a))));
      let O = await $({
        fetchData: () =>
          q({
            dataHref: this.pageLoader.getDataHref({
              href: (0, y.formatWithValidation)({ pathname: c, query: u }),
              skipInterpolation: !0,
              asPath: d,
              locale: p,
            }),
            hasMiddleware: !0,
            isServerRender: !1,
            parseJSON: !0,
            inflightCache: this.sdc,
            persistCache: !this.isPreview,
            isPrefetch: !0,
          }),
        asPath: t,
        locale: p,
        router: this,
      });
      if (
        ((null == O ? void 0 : O.effect.type) === "rewrite" &&
          ((a.pathname = O.effect.resolvedHref),
          (l = O.effect.resolvedHref),
          (u = { ...u, ...O.effect.parsedAs.query }),
          (d = O.effect.parsedAs.pathname),
          (e = (0, y.formatWithValidation)(a))),
        (null == O ? void 0 : O.effect.type) === "redirect-external")
      )
        return;
      let T = (0, i.removeTrailingSlash)(l);
      ((await this._bfl(t, d, r.locale, !0)) && (this.components[o] = { __appRouter: !0 }),
        await Promise.all([
          this.pageLoader._isSsg(T).then(
            (t) =>
              !!t &&
              q({
                dataHref: (null == O ? void 0 : O.json)
                  ? null == O
                    ? void 0
                    : O.dataHref
                  : this.pageLoader.getDataHref({ href: e, asPath: d, locale: p }),
                isServerRender: !1,
                parseJSON: !0,
                inflightCache: this.sdc,
                persistCache: !this.isPreview,
                isPrefetch: !0,
                unstable_skipClientCache: r.unstable_skipClientCache || (r.priority && !0),
              })
                .then(() => !1)
                .catch(() => !1),
          ),
          this.pageLoader[r.priority ? "loadPage" : "prefetch"](T),
        ]));
    }
    async fetchComponent(e) {
      let t = W({ route: e, router: this });
      try {
        let r = await this.pageLoader.loadPage(e);
        return (t(), r);
      } catch (e) {
        throw (t(), e);
      }
    }
    _getData(e) {
      let t = !1,
        r = () => {
          t = !0;
        };
      return (
        (this.clc = r),
        e().then((e) => {
          if ((r === this.clc && (this.clc = null), t)) {
            let e = Object.defineProperty(
              Error("Loading initial props cancelled"),
              "__NEXT_ERROR_CODE",
              { value: "E405", enumerable: !1, configurable: !0 },
            );
            throw ((e.cancelled = !0), e);
          }
          return e;
        })
      );
    }
    getInitialProps(e, t) {
      let { Component: r } = this.components["/_app"],
        n = this._wrapApp(r);
      return (
        (t.AppTree = n),
        (0, p.loadGetInitialProps)(r, { AppTree: n, Component: e, router: this, ctx: t })
      );
    }
    get route() {
      return this.state.route;
    }
    get pathname() {
      return this.state.pathname;
    }
    get query() {
      return this.state.query;
    }
    get asPath() {
      return this.state.asPath;
    }
    get locale() {
      return this.state.locale;
    }
    get isFallback() {
      return this.state.isFallback;
    }
    get isPreview() {
      return this.state.isPreview;
    }
    constructor(
      e,
      t,
      r,
      {
        initialProps: n,
        pageLoader: a,
        App: o,
        wrapApp: s,
        Component: l,
        err: u,
        subscription: c,
        isFallback: f,
        locale: d,
        locales: m,
        defaultLocale: g,
        domainLocales: v,
        isPreview: b,
      },
    ) {
      ((this.sdc = {}),
        (this.sbc = {}),
        (this.isFirstPopStateEvent = !0),
        (this._key = Y()),
        (this.onPopState = (e) => {
          let t,
            { isFirstPopStateEvent: r } = this;
          this.isFirstPopStateEvent = !1;
          let n = e.state;
          if (!n) {
            let { pathname: e, query: t } = this;
            this.changeState(
              "replaceState",
              (0, y.formatWithValidation)({ pathname: (0, P.addBasePath)(e), query: t }),
              (0, p.getURL)(),
            );
            return;
          }
          if (n.__NA) return void window.location.reload();
          if (!n.__N || (r && this.locale === n.options.locale && n.as === this.asPath)) return;
          let { url: a, as: o, options: i, key: s } = n;
          this._key = s;
          let { pathname: l } = (0, _.parseRelativeUrl)(a);
          (!this.isSsr ||
            o !== (0, P.addBasePath)(this.asPath) ||
            l !== (0, P.addBasePath)(this.pathname)) &&
            (!this._bps || this._bps(n)) &&
            this.change(
              "replaceState",
              a,
              o,
              Object.assign({}, i, {
                shallow: i.shallow && this._shallow,
                locale: i.locale || this.defaultLocale,
                _h: 0,
              }),
              t,
            );
        }));
      let E = (0, i.removeTrailingSlash)(e);
      ((this.components = {}),
        "/_error" !== e &&
          (this.components[E] = {
            Component: l,
            initial: !0,
            props: n,
            err: u,
            __N_SSG: n && n.__N_SSG,
            __N_SSP: n && n.__N_SSP,
          }),
        (this.components["/_app"] = { Component: o, styleSheets: [] }),
        (this.events = K.events),
        (this.pageLoader = a));
      let R = (0, h.isDynamicRoute)(e) && self.__NEXT_DATA__.autoExport;
      if (
        ((this.basePath = ""),
        (this.sub = c),
        (this.clc = null),
        (this._wrapApp = s),
        (this.isSsr = !0),
        (this.isLocaleDomain = !1),
        (this.isReady = !!(
          self.__NEXT_DATA__.gssp ||
          self.__NEXT_DATA__.gip ||
          self.__NEXT_DATA__.isExperimentalCompile ||
          (self.__NEXT_DATA__.appGip && !self.__NEXT_DATA__.gsp) ||
          (!R && !self.location.search && 0)
        )),
        (this.state = {
          route: E,
          pathname: e,
          query: t,
          asPath: R ? e : r,
          isPreview: !!b,
          locale: void 0,
          isFallback: f,
        }),
        (this._initialMatchesMiddlewarePromise = Promise.resolve(!1)),
        !r.startsWith("//"))
      ) {
        let n = { locale: d },
          a = (0, p.getURL)();
        this._initialMatchesMiddlewarePromise = D({ router: this, locale: d, asPath: a }).then(
          (o) => (
            (n._shouldResolveHref = r !== e),
            this.changeState(
              "replaceState",
              o ? a : (0, y.formatWithValidation)({ pathname: (0, P.addBasePath)(e), query: t }),
              a,
              n,
            ),
            o
          ),
        );
      }
      window.addEventListener("popstate", this.onPopState);
    }
  }
  K.events = (0, d.default)();
}
